<template>
  <ApplyDecision
    v-bind="props"
    component-type="ApplyDeclinedDecision"
    decision="declined"
    :component="component"
  />
</template>

<script setup lang="ts">
  import { useLocalizedComponents } from "@versatile-credit-apply/components"
  import { ApplyDecisionProps } from "@/models/apply/apply-models"
  import ApplyDecision from "@/components/apply/ApplyDecision.vue"

  const props = defineProps<ApplyDecisionProps>()

  const component = useLocalizedComponents(() => props.response, {
    ads_standard: () =>
      import("@/providers/ads_standard/components/AdsDeclinedDecision.vue"),
    aff_standard: () =>
      import("@/providers/aff_standard/components/AffDeclinedDecision.vue"),
    bread_standard: () =>
      import("@/providers/bread_standard/components/BreadDeclinedDecision.vue"),
    fortiva_standard: () =>
      import(
        "@/providers/fortiva_standard/components/FortivaDeclinedDecision.vue"
      ),
    genesis_standard: () =>
      import(
        "@/providers/genesis_standard/components/GenesisDeclinedDecision.vue"
      ),
    synchrony_standard: () =>
      import(
        "@/providers/synchrony_standard/components/SynchronyDeclinedDecision.vue"
      ),
  })
</script>
